// src/utils/pedidoUtils.js

export const getPedidoNumero = (pedido, usaIdDia = false) => {
  if (!pedido) {
    return '';
  }

  if (usaIdDia) {
    return pedido.idDia ?? pedido.id ?? '';
  }

  return pedido.id ?? pedido.idDia ?? '';
};

export const getComandaPedidoNumero = (item, usaIdDia = false) => {
  if (!item) {
    return '';
  }

  if (usaIdDia) {
    return item.pedidoIdDia ?? item.pedidoId ?? '';
  }

  return item.pedidoId ?? item.pedidoIdDia ?? '';
};
